import { Project } from "interfaces";

// import * as flowConfig from "flows/clustering/config";
import { projectIsClusteringAnalysis } from "flows/clustering/interfaces";

const ContextSummary = ({ project }: { project: Project }) => {
  if (!projectIsClusteringAnalysis(project)) {
    return null;
  }

  return null;

  // return (
  //   <div className="m-1">
  //     <p>
  //       Time-series are based on{" "}
  //       <span className="italic underline">
  //         {project.meta_data[flowConfig.TIMESTAMP_VAR]}
  //       </span>
  //       .
  //     </p>
  //   </div>
  // );
};

export default ContextSummary;
